/**
 * Мета данные ОО
 */
import { ClassifierShort } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class InstitutionMeta extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public id: number; /*Идентификатор БД*/
    public reorganization_name: string; /*Дополнительное наименование ОО на момент реорганизации*/
    public additional_name: string; /*Дополнительное наименование ОО*/
    public occupied_place: number; /*Фактическая наполняемость*/
    public total_place: number; /*Предельная наполняемость*/
    public educational_program_url: string; /*Ссылка на образовательную программу на официальном сайте*/
    public electronic_diary_vendor: string; /*Организация-разработчик "Электронного дневника"*/
    public electronic_diary_name: string; /*Название информационной системы "Электронного дневника"*/
    public electronic_diary_url: string; /*Ссылка для входа в сервис "Электронный дневник"*/
    public is_first_class: boolean; /*Будет запись в 1 класс в текущем году*/
    public is_site_initialized: boolean; /*Сайт инициализирован*/
    public employee_count: number; /*Общее количество сотрудников*/
    public statute_url: string; /*Ссылка на устав*/
    public direction_for_ip: string; /*Направление подготовки, специальности, профессии (кроме общего образования)*/
    public has_bookkeeping: boolean; /*Наличие бухгалтерии*/
    public is_small_setted: boolean; /*Малокомплектное (для школ)*/
    public schedule_string: string; /*Режим (часы, дни)*/
    public has_it_teachers: boolean; /*Наличие требуемой численности преподователей общепрофессиональных и специальных дисциплин, связанных с ИТ*/
    public is_budget_transfered: boolean; /*Переведено на нормативно-бюджетное финансирование*/
    public fgos_scoring: ClassifierShort[]; /*Использование современных оценочных процедур для оценки достижений по ФГОС*/
    public site_characteristics: ClassifierShort[]; /*Характеристики сайта ОО*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.id = json.id || null;
        this.reorganization_name = json.reorganization_name || null;
        this.additional_name = json.additional_name || null;
        this.occupied_place = json.occupied_place || null;
        this.total_place = json.total_place || null;
        this.educational_program_url = json.educational_program_url || null;
        this.electronic_diary_vendor = json.electronic_diary_vendor || null;
        this.electronic_diary_name = json.electronic_diary_name || null;
        this.electronic_diary_url = json.electronic_diary_url || null;
        this.is_first_class = json.is_first_class || null;
        this.is_site_initialized = json.is_site_initialized || null;
        this.employee_count = json.employee_count || null;
        this.statute_url = json.statute_url || null;
        this.direction_for_ip = json.direction_for_ip || null;
        this.has_bookkeeping = json.has_bookkeeping || null;
        this.is_small_setted = json.is_small_setted || null;
        this.schedule_string = json.schedule_string || null;
        this.has_it_teachers = json.has_it_teachers || null;
        this.is_budget_transfered = json.is_budget_transfered || null;
        this.fgos_scoring = [];
        if (json.fgos_scoring) {
          for (const i in json.fgos_scoring) {
            if ( json.fgos_scoring.hasOwnProperty( i ) ) {
                this.fgos_scoring.push(new ClassifierShort(json.fgos_scoring[i]));
            }
          }
        }
        this.site_characteristics = [];
        if (json.site_characteristics) {
          for (const i in json.site_characteristics) {
            if ( json.site_characteristics.hasOwnProperty( i ) ) {
                this.site_characteristics.push(new ClassifierShort(json.site_characteristics[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
